import type { Context } from '@opentelemetry/api'
import type { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto'
import { BatchSpanProcessor, type Span } from '@opentelemetry/sdk-trace-base'

import type { MutableAsyncLocalStorageContextManager } from './context/MutableAsyncLocalStorageContextManager'

export default class MXLSpanProcessor extends BatchSpanProcessor {
  private readonly enableMXLGlobalContext: boolean
  private readonly contextManager:
    | MutableAsyncLocalStorageContextManager
    | undefined

  constructor({
    exporter,
    enableMXLGlobalContext,
    contextManager,
  }: {
    exporter: OTLPTraceExporter
    enableMXLGlobalContext: boolean
    contextManager?: MutableAsyncLocalStorageContextManager
  }) {
    super(exporter)
    this.enableMXLGlobalContext = enableMXLGlobalContext
    this.contextManager = contextManager
  }

  override onStart(span: Span, parentContext: Context): void {
    this._setTraceAttributes(span)

    super.onStart(span, parentContext)
  }

  // will get set successfully at this point due to instrumentation-specific quirks
  override onEnd(span: Span): void {
    // Allow us to set attributes on the span after it is ended from the span itself
    // @ts-ignore
    span._ended = false

    this._setTraceAttributes(span)

    // @ts-ignore
    span._ended = true

    super.onEnd(span)
  }

  // This is done on a best-effort basis, and we can't guarantee that the attributes

  private _setTraceAttributes(span: Span): void {
    if (
      this.enableMXLGlobalContext &&
      this.contextManager != null &&
      typeof this.contextManager.getMutableContext === 'function'
    ) {
      const spanAttributes = span.attributes

      // We should only update attributes that aren't set already.
      // This ensures that we don't overwrite attributes set by the user.
      // Additionally in onEnd, some instrumentations such as mongodb will have
      // the "wrong" context defined and we won't have accurate trace attributes.
      const mutableContext = this.contextManager.getMutableContext()

      const traceAttributes = mutableContext?.traceAttributes
      if (traceAttributes != null) {
        traceAttributes.forEach((value, key) => {
          if (spanAttributes[key] == null) {
            span.setAttribute(key, value)
          }
        })
      }
    }
  }
}
